/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>

        <path d="M9.37300021,1.04505293e-15 C4.18800738,0.011040146 -0.00734652355,4.22130559 9.65903477e-06,9.40630495 C0.00736584162,14.5913043 4.2146494,18.7896486 9.39965268,18.7859764 C14.584656,18.7823041 18.7859885,14.5780046 18.7860002,9.393 C18.7749711,4.20215585 14.5638561,-1.17169166e-05 9.37300021,1.04505293e-15 Z M9.37300021,17.786 C4.74029384,17.7749605 0.992655508,14.0124121 1.00001078,9.37969843 C1.00736606,4.74698475 4.76693293,0.996355402 9.39965099,1.00002646 C14.0323691,1.00369753 17.7859871,4.76028048 17.7860002,9.393 C17.7755227,14.031788 14.0118,17.7865633 9.37300021,17.786 Z M8.87300021,7.62 L9.87300021,7.62 L9.87300021,14.325 L8.87300021,14.325 L8.87300021,7.62 Z M9.40800021,6.227 C9.86915797,6.227 10.2430002,5.85315777 10.2430002,5.392 C10.2430002,4.93084223 9.86915797,4.557 9.40800021,4.557 C8.94684244,4.557 8.57300021,4.93084223 8.57300021,5.392 C8.57300021,5.85315777 8.94684244,6.227 9.40800021,6.227 Z" className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'MoreInfoStrokeIcon';

export default Icon;
